/* @flow */

import React from 'react';

type Props = {
    size: number,
};

export const MessengerColoredIcon = ({size = 14}: Props) => {
    return <img alt='Messenger icon' style={{width: size}} src='/include/images/messenger.png' />;
};
